import { renderStateName } from '@/screens/scan/states'
import { normalizeLabel } from '@/screens/scan/lib/labels'
import type { ChecklistItem } from '@/screens/scan/types'
import { DetailRow } from './DetailRow'

/** Checklist item metadata card — mirrors ramp-web-app ScannerChecklistItemCard. */
export function ChecklistItemCard({ item }: { item?: ChecklistItem }) {
  if (!item) return null

  const uniqueStates = item.states?.length ? [...new Set(item.states.filter(Boolean))] : []
  const states = uniqueStates.length ? uniqueStates.map(renderStateName).join(', ') : undefined
  const typeOfInsurance = item.typeOfInsurances?.length ? item.typeOfInsurances.join(', ') : undefined
  const subTypeOfInsurance = item.subTypeOfInsurances?.length ? item.subTypeOfInsurances.join(', ') : undefined

  const hasRows = Boolean(
    item.description ||
    item.type ||
    item.scope ||
    item.statutes ||
    item.status ||
    item.topic ||
    states ||
    typeOfInsurance ||
    subTypeOfInsurance
  )

  if (!hasRows) return null

  return (
    <div className='ramp-scan-card'>
      <div className='ramp-scan-card-title'>Checklist Item Details</div>
      <div className='ramp-scan-card-body'>
        <DetailRow label='Description' value={item.description} />
        <DetailRow label='Type' value={item.type ? normalizeLabel(item.type) : undefined} />
        <DetailRow label='Scope' value={item.scope ? normalizeLabel(item.scope) : undefined} />
        <DetailRow label='Source' value={item.statutes ? normalizeLabel(item.statutes) : undefined} />
        <DetailRow label='Status' value={item.status ? normalizeLabel(item.status) : undefined} />
        <DetailRow label='Topic' value={item.topic} />
        <DetailRow label='States' value={states} />
        <DetailRow label='Type of Insurance' value={typeOfInsurance} />
        <DetailRow label='Sub-Type of Insurance' value={subTypeOfInsurance} />
      </div>
    </div>
  )
}
